// file-explore.config.js
export const FILE_EXPLORE_ROUTE_ACCESS = {
  // Documentación - Backend
  "/help/documentation/backend": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/backend/index-js": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/backend/whatsapp-manager": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/backend/app-js": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/backend/session-manager": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  
  // Documentación - Frontend
  "/help/documentation/frontend": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/frontend/help-context": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/frontend/help-component": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/frontend/help-leftnav": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  
  // Documentación - API
  "/help/documentation/api": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/api/auth": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/api/vehicles": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/api/users": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  
  // Documentación - Base de Datos
  "/help/documentation/database": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/database/schema": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
  "/help/documentation/database/migrations": ["Administrador", "vehicle", "thirdParty", "RRHH", "CT", "CO", "MC", "ADO", "Operador", "Manifiestos de Carga", "Coordinador de operaciones", "TDCLL Usuarios", "TDCLLV", "TDCLLU", "CUV", "LUV"],
};

export const HELP_ROUTES_FILE_EXPLORE = {
  // Documentación - Backend
  backend: {
    path: "/help/documentation/backend",
    title: "Backend",
    subtitle: "Centro de Ayuda/Documentación/Backend",
    category: "documentation",
    parent: "Documentación"
  },
  backendIndexJs: {
    path: "/help/documentation/backend/index-js",
    title: "index.js",
    subtitle: "Centro de Ayuda/Documentación/Backend/index.js",
    category: "documentation",
    parent: "Backend"
  },
  backendWhatsappManager: {
    path: "/help/documentation/backend/whatsapp-manager",
    title: "whatsappManager.js",
    subtitle: "Centro de Ayuda/Documentación/Backend/whatsappManager.js",
    category: "documentation",
    parent: "Backend"
  },
  backendAppJs: {
    path: "/help/documentation/backend/app-js",
    title: "app.js",
    subtitle: "Centro de Ayuda/Documentación/Backend/app.js",
    category: "documentation",
    parent: "Backend"
  },
  backendSessionManager: {
    path: "/help/documentation/backend/session-manager",
    title: "sessionManager.js",
    subtitle: "Centro de Ayuda/Documentación/Backend/sessionManager.js",
    category: "documentation",
    parent: "Backend"
  },
  
  // Documentación - Frontend
  frontend: {
    path: "/help/documentation/frontend",
    title: "Frontend",
    subtitle: "Centro de Ayuda/Documentación/Frontend",
    category: "documentation",
    parent: "Documentación"
  },
  frontendHelpContext: {
    path: "/help/documentation/frontend/help-context",
    title: "HelpContext.js",
    subtitle: "Centro de Ayuda/Documentación/Frontend/HelpContext.js",
    category: "documentation",
    parent: "Frontend"
  },
  frontendHelpComponent: {
    path: "/help/documentation/frontend/help-component",
    title: "Help.jsx",
    subtitle: "Centro de Ayuda/Documentación/Frontend/Help.jsx",
    category: "documentation",
    parent: "Frontend"
  },
  frontendHelpLeftnav: {
    path: "/help/documentation/frontend/help-leftnav",
    title: "HelpLeftNav.jsx",
    subtitle: "Centro de Ayuda/Documentación/Frontend/HelpLeftNav.jsx",
    category: "documentation",
    parent: "Frontend"
  },
  
  // Documentación - API
  api: {
    path: "/help/documentation/api",
    title: "API",
    subtitle: "Centro de Ayuda/Documentación/API",
    category: "documentation",
    parent: "Documentación"
  },
  apiAuth: {
    path: "/help/documentation/api/auth",
    title: "Autenticación",
    subtitle: "Centro de Ayuda/Documentación/API/Autenticación",
    category: "documentation",
    parent: "API"
  },
  apiVehicles: {
    path: "/help/documentation/api/vehicles",
    title: "Vehículos",
    subtitle: "Centro de Ayuda/Documentación/API/Vehículos",
    category: "documentation",
    parent: "API"
  },
  apiUsers: {
    path: "/help/documentation/api/users",
    title: "Usuarios",
    subtitle: "Centro de Ayuda/Documentación/API/Usuarios",
    category: "documentation",
    parent: "API"
  },
  
  // Documentación - Base de Datos
  database: {
    path: "/help/documentation/database",
    title: "Base de datos",
    subtitle: "Centro de Ayuda/Documentación/Base de datos",
    category: "documentation",
    parent: "Documentación"
  },
  databaseSchema: {
    path: "/help/documentation/database/schema",
    title: "Esquema",
    subtitle: "Centro de Ayuda/Documentación/Base de datos/Esquema",
    category: "documentation",
    parent: "Base de Datos"
  },
  databaseMigrations: {
    path: "/help/documentation/database/migrations",
    title: "Migraciones",
    subtitle: "Centro de Ayuda/Documentación/Base de datos/Migraciones",
    category: "documentation",
    parent: "Base de Datos"
  },
};

// Función utilitaria para combinar rutas de acceso
export const combineRouteAccess = (mainRoutes, fileExploreRoutes) => {
  return { ...mainRoutes, ...fileExploreRoutes };
};

// Función utilitaria para combinar rutas de help
export const combineHelpRoutes = (mainRoutes, fileExploreRoutes) => {
  return { ...mainRoutes, ...fileExploreRoutes };
};